export const detailTheme = {
  actionIcon: 'palette.tertiary.30',
  icon: 'palette.tertiary.70',
  text: 'palette.neutral.95',
  title: 'palette.tertiary.60',
};
